import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import { useNotification } from "@hooks/useNotification";

import ModalIndex from "@Modals/layout/index";

import { IndividualObjective } from "@services/developmentPlan";

export default function ModalDeleteIndividualObjective(props) {
  const { onCloseClicked, isOpen, individualObjective } = props;

  const { t } = useTranslation("assesment.frequency");

  const { showError, showSuccess } = useNotification();

  const [isDeleting, setIsDeleting] = useState(false);

  async function handleDelete() {
    try {
      setIsDeleting(true);
      if (individualObjective) {
        await IndividualObjective.deleteById(individualObjective._id);
        showSuccess("delete_action_success", { object: "objective" });
        onCloseClicked();
      }
    } catch (error) {
      console.error(error);
      showError("error");
    }

    setIsDeleting(false);
  }

  return (
    <ModalIndex
      isOpen={isOpen}
      onClickClose={onCloseClicked}
      isLoading={isDeleting}
      buttonOptions={{
        click: handleDelete,
        color: "green",
        title: t("Supprimer"),
      }}
      buttonCancelOptions={{
        click: onCloseClicked,
        color: "outlined",
        title: t("Annuler"),
      }}
    >
      <h3 className="arh-px-6 arh-font-poppins arh-text-2xl arh-font-semibold arh-text-darkColor">
        {t(`Êtes-vous sûr de vouloir supprimer`)} {t("cet objectif")}?
      </h3>
    </ModalIndex>
  );
}
